import { render } from "./mainTab.vue?vue&type=template&id=fe849ea0&scoped=true"
import script from "./mainTab.vue?vue&type=script&lang=js"
export * from "./mainTab.vue?vue&type=script&lang=js"

import "./mainTab.vue?vue&type=style&index=0&id=fe849ea0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe849ea0"]])

export default __exports__